import * as React from "react";
import {CrudPage} from "../crud/CrudPage";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {CrudList} from "../crud/CrudList";
import {Input} from "../form/fields/Input";
import {Field} from "../form/Field";
import {BooleanRadios} from "../form/fields/BooleanRadios";
import {api} from "../../api";
import {Select} from "../form/fields/Select";
import {Col, Row, Container} from "reactstrap";
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export class LocalGovernmentAreaFormData {
    @observable code = '';
    @observable name = '';
    @observable state_id: number|null = null;
    @observable is_active = true;
}

export class LocalGovernmentAreaForm extends CrudForm {
    modelName = 'LocalGovernmentArea';

    renderFields() {
        return (
            <>
                <Field
                    label="Code"
                    name="code"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />

                <Field
                    label="Name"
                    name="name"
                    component={Input}
                    required={true}
                    store={this.formStore}
                />

                <Field
                    label="State"
                    name="state_id"
                    component={Select}
                    required={true}
                    loadOptions={api.state.getListAction}
                    store={this.formStore}
                />

                <Field
                    name="is_active"
                    component={BooleanRadios}
                    trueLabel="Active"
                    falseLabel="In-Active"
                    store={this.formStore}
                />
            </>
        );
    }
}

export class LocalGovernmentAreaFilterForm {
    @observable state_id = null;
}

export class LocalGovernmentAreaList extends CrudList {
    modelName = 'LocalGovernmentArea';

    defaultSortColumn = 'state.name';
    defaultSortDirection = 'asc';

    colums() {
        return [
            {
                name: "state.code",
                label: "State Code",
                sort: true,
            },
            {
                name: "state.name",
                label: "State",
                sort: true,
            },
            {
                name: "name",
                label: "LGA",
                sort: true,
            },
            {
                name: "code",
                label: "LGA Code",
                sort: true,
            },
        ];
    }

    idColumn() {
        return '';
    }

    renderFilters() {
        return (
            <Container>
            <Row className="form-row">
                    <Col md={5}>
                        <ToastContainer autoClose={5000} />
                    </Col>
            </Row>
            <Row className="form-row">
                <Col md={3} lg={4} xl={3}>
                    <Field
                        name="state_id"
                        placeholder="Select State"
                        component={Select}
                        loadOptions={api.state.getListAction}
                        store={this.filterFormStore}
                    />
                </Col>

                <Col md={3} lg={4} xl={3} className="grid-search">
                    {this.renderSearch()}
                </Col>
            </Row>
            </Container>
        );
    }
}

export class LocalGovernmentAreaPage extends CrudPage {
    modelName = 'LocalGovernmentArea';
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/LocalGovernmentAreaPage.tsx